import {createContext} from 'react'



export const PharmaContext = createContext(null)